import { useAdminUpdate } from '@reapitform/hooks'
import { AdminReviewCard, AdminReviewCardPayload } from '../types'

/** Creates a review card under a form version (`POST …/versions/{versionRef}/review-cards`). */
export const useCreateAdminReviewCard = (formReferenceID: string, versionReferenceID: string) =>
  useAdminUpdate<AdminReviewCardPayload, AdminReviewCard>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/review-cards`,
    method: 'POST',
    errorMessage: 'Failed to create the review card',
    successMessage: 'Review card created',
  })
